import createDateOfBirthString from '../../../utils/createDateOfBirthStringFromObject';
import getArvatoFormData from './getArvatoFormData';
import getSelectedArvatoPaymentOption from './getSelectedArvatoPaymentOption';

export const getArvatoPersonalDetails = (state) => {
  const formData = getArvatoFormData(state);
  const useCompanyFields = formData.arvatoCustomerCategory === 'COMPANY';
  const isDirectDebit = getSelectedArvatoPaymentOption(state)?.directDebitAvailable;
  
  const customerSpecificFields = useCompanyFields
    ? {
      companyName: formData.companyName || null,
      email: formData.email || null,
      contactNumber: formData.contactNumber || null,
      identificationNumber: formData.companyIdentificationNumber || null,
      vatId: formData.euVATNumber || null,
    } : {
      salutation: formData.salutation || null,
      firstName: formData.firstName || null,
      lastName: formData.lastName || null,
      email: formData.email || null,
      contactNumber: formData.contactNumber || null,
      identificationNumber: formData.socialSecurityNumber || null,
      dateOfBirth: createDateOfBirthString(formData.dateOfBirth),
    };
  
  return {
    arvatoCustomerCategory: formData.arvatoCustomerCategory || null,
    ...customerSpecificFields,
    bankAccount: isDirectDebit ? formData.iban || null : null,
  };
};

export const getArvatoPaymentData = (state) => {
  const selectedSubArvatoMethod = getSelectedArvatoPaymentOption(state);
  return {
    subPaymentMethod: selectedSubArvatoMethod?.type || null,
    paymentNumber: selectedSubArvatoMethod?.installmentInfo?.profileNumber || null,
  };
};
